import { useSearchParams } from 'react-router-dom';

const ERROR_LABELS: Record<string, string> = {
  email_not_allowed: 'Cet email Google n\'est pas autorisé à utiliser l\'application.',
  state_mismatch: 'Erreur de sécurité OAuth (state mismatch). Réessaie.',
  missing_params: 'Paramètres OAuth manquants. Réessaie.',
  callback_failed: 'Échec de l\'authentification Google.',
};

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const email = searchParams.get('email');
  const detail = searchParams.get('detail');

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="bg-white rounded-lg shadow-sm border border-slate-200 max-w-md w-full p-8">
        <h1 className="text-2xl font-semibold tracking-tight text-center">
          Factures fournisseurs · KESTIO
        </h1>
        <p className="text-sm text-slate-500 text-center mt-2">
          Connexion réservée aux comptes Google autorisés.
        </p>

        {error && (
          <div className="mt-4 rounded-md bg-red-50 ring-1 ring-inset ring-red-200 px-3 py-2 text-sm text-red-800">
            <p>{ERROR_LABELS[error] ?? `Erreur : ${error}`}</p>
            {email && (
              <p className="mt-1 text-xs">
                Email tenté : <code>{email}</code>
              </p>
            )}
            {detail && (
              <p className="mt-1 text-xs text-red-700">{detail}</p>
            )}
          </div>
        )}

        <a
          href="/auth/google"
          className="mt-6 flex items-center justify-center gap-3 w-full px-4 py-2.5 rounded-md bg-white ring-1 ring-slate-300 hover:bg-slate-50 text-slate-700 font-medium transition-colors"
        >
          <GoogleIcon />
          Se connecter avec Google
        </a>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden>
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.2 6.2 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.6 16 18.9 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.2 6.2 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.3 0 10.1-2 13.7-5.3l-6.3-5.3c-2 1.5-4.6 2.6-7.4 2.6-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4 5.8l6.3 5.3c-.4.4 6.4-4.7 6.4-15.1 0-1.3-.1-2.4-.4-3.5z"
      />
    </svg>
  );
}
